var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#a7b9c5;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5,1.42A7.08,7.08,0,1,0,15.58,8.5,7.08,7.08,0,0,0,8.5,1.42ZM8.5,0A8.5,8.5,0,1,1,0,8.5,8.51,8.51,0,0,1,8.5,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.61,13.55C6.4,13.55,4.4,12.24,4,10.43a.71.71,0,0,1,1.38-.34v.07c.22,1.07,1.6,2,3.19,2a3.22,3.22,0,0,0,3.17-1.88l0-.09a.71.71,0,0,1,1.39.3C12.81,12.26,10.81,13.55,8.61,13.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.97,
    cy: 6.74,
    r: 1.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.02,
    cy: 6.74,
    r: 1.03,
    transform: "translate(-0.95 0.99) rotate(-8.68)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 27,
    height: 27
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.02,
    y: 9.59,
    width: 19.18,
    height: 13.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.94,
    y: 5.7,
    width: 12.06,
    height: 12.06
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.99,
    y: 5.7,
    width: 12.06,
    height: 12.06
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon4);
export default __webpack_public_path__ + "static/media/chat-icon4.3fe49f0457a6ffc8b0e87b4a86409b7e.svg";
export { ForwardRef as ReactComponent };